import React, { useContext, useRef } from 'react';
import { useToggle } from '../../Hooks/booleanHooks';
import EDIconButton from '../../BaseComponents/Buttons/IconButton/EDIconButton';
import { EDListItemButton } from '../../BaseComponents/List/Components/EDListItem';
import LegendMenu from './LegendMenu';
import { CommonPropsAndTypes } from '../../BaseComponents/_Types/StandardComponentProps';
import { ILegendProps } from './Legend';
import { AvenyContext } from '../../Features/AvenyContext';
import EDMenuItem from '../../BaseComponents/Menu/EDMenuItem';
import EDTypography from '../../BaseComponents/Typography/EDTypography';
import EDIcon from '../../BaseComponents/Icon/EDIcon';

interface IProps extends ILegendProps {
  margin?: CommonPropsAndTypes.StandardSpacingType;
  expanded?: boolean;
  inMobileMenu?: boolean;
  onClose?: () => void;
}

const LegendMenuButton: React.FC<React.PropsWithChildren<IProps>> = props => {
  const avenyContext = useContext(AvenyContext);
  const { margin, expanded, ...rest } = props;
  const [open, toggleOpen] = useToggle();
  const ref = useRef<any>(null);

  const toggle = () => {
    if (open && props.onClose) {
      props.onClose();
    }

    if (avenyContext.formHasChanged) {
      avenyContext.setOpenChoiceDialog(true, () => {
        toggleOpen();
      });
    } else {
      toggleOpen();
    }
  };

  const legendMenuComp = (
    <LegendMenu {...rest} open={open} toggleOpen={toggle} menuRef={ref} />
  );

  return props.posts.length > 0 ? (
    props.inMobileMenu ? (
      <>
        <EDMenuItem color="inherit" onClick={toggle}>
          <EDIcon iconType="legend_active" />
          <EDTypography variant="subtitle1" sx={{ marginLeft: 2 }}>
            Färger och betydelser
          </EDTypography>
        </EDMenuItem>
        {legendMenuComp}
      </>
    ) : expanded ? (
      <div ref={ref}>
        <EDListItemButton
          disableVerticalPadding
          onClick={toggle}
          style={{ paddingLeft: '0px', paddingRight: '0px' }}
        >
          <EDIconButton
            disableBackground
            icon="legend_active"
            iconSize="default"
            tooltip=""
            margin="none"
            paddingLeft={expanded ? '28px' : undefined}
          />
          {expanded && <EDTypography>Färger och betydelser</EDTypography>}
        </EDListItemButton>
        {legendMenuComp}
      </div>
    ) : (
      <div ref={ref}>
        <EDIconButton
          icon="legend_active"
          onClick={toggle}
          tooltip="Visa färger och betydelser"
          margin="none"
        />
        {legendMenuComp}
      </div>
    )
  ) : null;
};

export default LegendMenuButton;
